import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { FieldConfig, PriceRange } from 'src/app/models/types/Filters.type';
import { FiltersService } from 'src/app/services/filters.service';
import { InputComponent } from '../input/input.component';
import { TypeFilter } from 'src/app/models/enums/TypeFilter.enum';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-price-range-input',
  imports: [
    InputComponent,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './price-range-input.component.html',
  styleUrl: './price-range-input.component.scss'
})
export class PriceRangeInputComponent {

  @Input('config') config!: FieldConfig;
  @Input('priceRange') priceRange!: PriceRange | null;

  private formControl!: FormControl;

  public minControl!: FormControl;
  public minConfig: FieldConfig = {
    field: 'min',
    type: TypeFilter.CURRENCY,
    label: 'from'
  }
  public maxControl!: FormControl;
  public maxConfig: FieldConfig = {
    field: 'max',
    type: TypeFilter.CURRENCY,
    label: 'to'
  }

  constructor(
    private readonly filtersService: FiltersService,
    public readonly authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.formControl = this.filtersService.getFormControl(this.config.field);

    let validators: ValidatorFn[] | null = null;
    if (this.priceRange) {
      let { min, max } = this.priceRange;
      validators = [Validators.min(min), Validators.max(max)];
    }

    this.minControl = new FormControl('', validators);

    this.maxControl = new FormControl('', validators);

    this.formControl.valueChanges.subscribe((value) => {
      if (value == null || (Array.isArray(value) && value.length === 0)) {
        this.minControl.reset('', { emitEvent: false });
        this.maxControl.reset('', { emitEvent: false });
      }
    });

    this.minControl.valueChanges.subscribe((val) => {
      this.handleValueChange(val, true)
    });

    this.maxControl.valueChanges.subscribe((val) => {
      this.handleValueChange(val, false)
    });

  }

  handleValueChange(value: string, isMinField: boolean) {
    let formControlValue = [...this.formControl.value];
    let index = isMinField ? 0 : 1;
    if (formControlValue.length > 0) {
      formControlValue[index] = value;
    } else {
      formControlValue = [this.priceRange?.min || 0, this.priceRange?.max || 0]
    }
    this.formControl.setValue(formControlValue);
  }

}
